import { render, staticRenderFns } from "./DashboardData.vue?vue&type=template&id=64edd7ce&scoped=true&"
import script from "./DashboardData.vue?vue&type=script&lang=js&"
export * from "./DashboardData.vue?vue&type=script&lang=js&"
import style0 from "./DashboardData.vue?vue&type=style&index=0&id=64edd7ce&scoped=true&lang=scss&"
import style1 from "./DashboardData.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64edd7ce",
  null
  
)

export default component.exports